import {css} from '@emotion/css';

import {Breakpoints, mq, negative} from '../../../../styles/js/mixins';
import {colours, fonts, spacing} from '../../../../styles/js/variables';

const styles = {
  container: css`
    label: richText__container;

    ul {
      padding-left: ${spacing.M};
      list-style-type: unset;
    }
    blockquote {
      margin: 0;
      padding: ${spacing.XXS} ${spacing.S};
      background-color: ${colours.background.OFF_WHITE};
    }
    p {
      &:not(:last-of-type) {
        margin-bottom: ${spacing.XS};
      }
    }
  `,
  nested: css`
    label: richText__nested;
    padding: 0;
  `,
  blockQuote: css`
    label: richText__blockQuote;
    padding: ${spacing.L};

    p {
      font-weight: ${fonts.weight.SEMI_BOLD};
      font-size: ${fonts.size.XXL};
    }
  `,
  imageContainer: css`
    label: richText__imageContainer;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: start;
    width: 100%;
    padding-bottom: ${spacing.XXS};
    img {
      width: 100%;
      height: auto;
      max-height: 40rem;
      padding-bottom: ${spacing.XXXS};
      object-fit: cover;
      ${mq(Breakpoints.TABLET)} {
        max-height: 50rem;
      }
    }
  `,
  imageDescription: css`
    label: richText__imageDescription;
    margin-bottom: 0;
    color: ${colours.font.LIGHT_GRAY};
  `,
  heading: css`
    label: richText__heading;
    // When the browser automatically scrolls to these elements, which are used as anchors.
    // The problem is that this element gets to the absolute top of the screen, without any margin at the top.
    // Since we have a 40px fixed menu, this anchored element stays behind the menu.
    // This rule makes sure that there is a 60px (6rem) margin at the top of the targeted item (automatically
    // scrolled to when clicking the anchor). This way you can see the menu at the top and the title below it.
    &:target {
      &::before {
        display: block;
        height: ${spacing.L};
        margin-top: ${negative(spacing.L)}; // stylelint-disable-line sh-waqar/declaration-use-variable
        content: '';
        ${mq(Breakpoints.DESKTOP)} {
          height: ${spacing.XS};
          margin-top: ${negative(spacing.XS)}; // stylelint-disable-line sh-waqar/declaration-use-variable
        }
      }
    }
  `,
};

export default styles;
